import React, {useEffect} from 'react';
import './App.css';
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import {getAnalytics} from "firebase/analytics";
import {AuthProvider} from "./utils/AuthProvider";
import '@fontsource/inter';
import {Box, CssBaseline, CssVarsProvider, extendTheme} from "@mui/joy";
import {Router} from "./utils/Router";
import {FeedbackProvider} from "./utils/FeedbackContext";

if (!firebase.apps.length) {
    const app = firebase.initializeApp({
        apiKey: "AIzaSyAw4b38ogVSF5QGQDQmPf7owjQ61KlLUNk",
        authDomain: "camping-d2e66.firebaseapp.com",
        projectId: "camping-d2e66",
        storageBucket: "camping-d2e66.firebasestorage.app",
        messagingSenderId: "793987544801",
        appId: "1:793987544801:web:3bf15134085a314960a9a0",
        measurementId: "G-YEQB3S8YZV"
    })
    getAnalytics(app);
}

const baseTheme = extendTheme();
const darkOnlyTheme = extendTheme({
    cssVarPrefix: "sidebar_",
    colorSchemes: {
        light: baseTheme.colorSchemes.light,
        dark: baseTheme.colorSchemes.dark,
    },
});

function App() {

    useEffect(() => {
        console.info('\x1b[34m%s\x1b[0m', // \x1b[38;5;33m
            "\n\n" +
            "        Developed with <3 by\n" +
            "        DANIELE DI GREGORIO\n" +
            "      www.danieledigregorio.it\n")
    }, []);

    return (
        <div>
            <AuthProvider>
                <FeedbackProvider>
                    <CssVarsProvider theme={darkOnlyTheme} defaultMode="light">
                        <CssBaseline />
                        <Box sx={{
                            minHeight: '100%',
                            maxWidth: '100vw',
                            backgroundColor: "var(--joy-palette-background-body)",
                        }}
                        >
                            <Router />
                        </Box>
                    </CssVarsProvider>
                </FeedbackProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
